import { ApiResponse } from '@/interfaces/apiresponse.interface';
import { EngagementResponse } from '@/interfaces/engagementResponse.interface';
import { AppNav } from '@/routes/app-nav';
import { EngagementAccessService } from '@/services/engagement-access.service';
import { TitleService } from '@/services/title.service';
import Helpers from '@/shared/helpers';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-request-access-page',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './request-access-page.component.html',
})
export class RequestAccessPageComponent implements OnInit, OnDestroy {
  private destroyed = new Subject<any>();
  private helpers: Helpers;

  messageKey: string = "requestAccessPage";
  engagementEntries: EngagementResponse[] = [];
  loading: boolean = false;
  showingRequestAccessDialog: boolean = false;
  selectedEngagement?: EngagementResponse;
  
  @ViewChild(Table) engagementEntryTable!: Table;

  constructor(
    private titleService: TitleService,
    private translocoService: TranslocoService,
    private messageService: MessageService,
    private engagementAccessService: EngagementAccessService,
  ) {
    this.helpers = Helpers.getInstance(this.translocoService);
  }

  ngOnInit(): void {
    this.titleService.setTitle(AppNav.StatusMonitor.title);
    this.loadEngagementEntries();
  };

  loadEngagementEntries(): void {
    this.loading = true;
    this.engagementAccessService.engagements()
      .then(
        (response: HttpResponse<ApiResponse>) => {
          this.loading = false;
          const entries = (response.body || []) as EngagementResponse[];
          this.engagementEntries = entries;
        },
        (response: HttpErrorResponse) => {
          this.loading = false;
          this.helpers.showApiResponseMessage(response, this.messageService, this.messageKey);
        }
      );
  }

  showRequestAccessDialog(engagement: EngagementResponse){
    this.selectedEngagement = engagement;
    this.showingRequestAccessDialog = true;
  }

  ngOnDestroy(): void {
    this.destroyed.next(undefined);
    this.destroyed.complete();
  }
}
